var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c("el-input", {
            ref: _vm.reference,
            attrs: {
              placeholder: _vm.prop.defaultValue,
              minlength: parseInt(_vm.prop.min),
              maxlength: parseInt(_vm.prop.max)
            },
            model: {
              value: _vm.currentValue,
              callback: function($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue"
            }
          })
        : _c("p", [_vm._v("\n        " + _vm._s(_vm.currentValue) + "\n    ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }